import { Component, Mixins } from 'vue-property-decorator';
import { AppFiltersMixin } from '@/mixins/AppFiltersMixin';
import { AppHypotheekMixin } from '../../../../hypotheken/mixins/AppHypotheekMixin';
import { State } from 'vuex-class';
import { IAppConfig } from '@/model/IAppConfig';

@Component({})
export default class AppFooterContact extends Mixins(AppFiltersMixin, AppHypotheekMixin) {
  @State(state => state.config)
  public config!: IAppConfig;
}
